var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('Loader'),(_vm.isDesktop)?_c('menuDesktop'):_c('menuMobile'),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-float",attrs:{"href":"https://wa.me/5491170607500?","target":"_blank","rel":"noopener noreferrer"}},[_c('i',{staticClass:"bi bi-whatsapp"})])
}]

export { render, staticRenderFns }